/*
NOTE: Using this as a sandbox environment to validate the default theme and 
determine what other elements need css variables to improve theming.
*/
import { css } from 'styled-components';
const BG_ACCENT = '#344772';
const ZEBRA1 = '#843996';
const ZEBRA2 = '#b459ca';
const ZEBRA3 = '#465586'; //'#3c9664';
const ZEBRA4 = '#38446B'; //'#5dc28a';
const ZEBRA5 = '#ff7b00';
const ZEBRA6 = '#ffa047';
const RED_ALT = '#b61211';


export const WHITE = '#1c2235';
export const GRAY1 = WHITE; //'#EEEEEE';
export const GRAY2 = '#E7E7E7';
export const GRAY3 = '#D7D8D8'; // DEALER MESSAGE
export const GRAY4 = '#D2D1D2';
export const GRAY5 = '#CFCFD1'; // DISABLED BUTTON
export const GRAY6 = '#808080';
export const GRAY7 = '#888888'; // SUBHEADER BG (IE. PREVIEW)
export const GRAY8 = '#444444'; // HEADER BG
export const BLACK = '#ffffff';
export const BROWN1 = '#BFBCAC'; // SELLER ITEMS
export const RED1 = '#FF0000'; // ERROR MESSAGES
export const RED2 = '#DB2828'; // NO SALE
export const RED3 = '#009E0F'; // BIDDER BAR
export const BLUE1 = '#D3EFFC'; // WATCHING
export const BLUE2 = '#32A9D2'; // WATCH BUTTON
export const WATCH_GRADIENT = {
  color1: {
    hex: '#32A9D2',
    hsla: 'hsla(195, 64%, 51%, 1)',
  },
  color2: {
    hex: '#344772',
    hsla: 'hsla(222, 37%, 33%, 1)',
  },
  gradient: css`
    background: hsla(195, 64%, 51%, 1);
    background: linear-gradient(
      145deg,
      hsla(195, 64%, 51%, 1) 0%,
      hsla(222, 37%, 33%, 1) 100%
    );
    background: -moz-linear-gradient(
      145deg,
      hsla(195, 64%, 51%, 1) 0%,
      hsla(222, 37%, 33%, 1) 100%
    );
    background: -webkit-linear-gradient(
      145deg,
      hsla(195, 64%, 51%, 1) 0%,
      hsla(222, 37%, 33%, 1) 100%
    );
    filter: progid: DXImageTransform.Microsoft.gradient( startColorstr="#32A9D2", endColorstr="#344772", GradientType=1 );
  `,
};
export const BLUE3 = '#04A1D3'; // CLERK MESSAGE
export const BLUE4 = RED_ALT; // UTILITY BUTTONS
export const BLUE5 = '#1C6C98'; // GLOBAL MESSAGE
export const YELLOW1 = '#EEBF04'; //'#FBCC08'; // PROXY/PENDING
export const YELLOW2 = '#D8B006'; // BORDER
export const GREEN1 = '#21BA45'; // WON MESSAGE
export const GREEN2 = '#009E0F'; // BID BUTTON
export const ORANGE1 = RED_ALT; // PINNED MESSAGE




const BACKGROUND = WHITE;

const DIVIDER = WHITE;
const DARK_TEXT_COLOR = BLACK;
const LIGHT_TEXT_COLOR = BLACK;

/*
bodyBgColor
formElementBgColor
promoBgColor
activeBtnBgColor
btnBgColor
highBidTextColor
fixedBidDetailsBgColor
*/

export const abyssTheme = (overrides = {}) => {
  return Object.assign(
    {
      black: BLACK,
      blue1: BLUE1,
      blue2: BLUE2,
      blue3: BLUE3,
      blue4: BLUE4,
      blue5: BLUE5,
      brown1: BROWN1,
      gray1: GRAY1,
      gray2: GRAY2,
      gray3: GRAY3,
      gray4: GRAY4,
      gray5: GRAY5,
      gray6: GRAY6,
      gray7: GRAY7,
      gray8: GRAY8,
      green1: GREEN1,
      green2: GREEN2,
      orange1: ORANGE1,
      red1: RED1,
      red2: RED2,
      red3: RED3,
      white: WHITE,
      yellow1: YELLOW1,
      yellow2: YELLOW2,
      activeLaneTextColor: GREEN2,
      badgeValueTextColor: BLUE4,
      bidActivityBgColor1: ZEBRA1,
      bidActivityBgColor2: ZEBRA2,
      bidActivityTextColor: LIGHT_TEXT_COLOR,
      bidBtnBgColor: GREEN2,
      bidBtnTextColor: LIGHT_TEXT_COLOR,
      blockAttrsBgColor1: ZEBRA3,
      blockAttrsBgColor2: ZEBRA4,
      blockAttrsTextColor1: LIGHT_TEXT_COLOR,
      blockAttrsTextColor2: LIGHT_TEXT_COLOR,
      cancelBtnBgColor: RED2,
      cancelBtnTextColor: "#000",
      clerkMsgBgColor: BLUE3,
      clerkMsgTextColor: LIGHT_TEXT_COLOR,
      crAttrsBgColor1: ZEBRA3,
      crAttrsBgColor2: ZEBRA4,
      crAttrsTextColor1: LIGHT_TEXT_COLOR,
      crAttrsTextColor2: LIGHT_TEXT_COLOR,
      darkTextColor: DARK_TEXT_COLOR,
      dealerMsgBgColor: RED_ALT,
      dealerMsgTextColor: LIGHT_TEXT_COLOR,
      disabledBtnBgColor: GRAY6,
      disabledBtnTextColor: LIGHT_TEXT_COLOR,
      divider: DIVIDER,
      dividerLine: `.15em solid ${DIVIDER}`,
      errorColor: RED1,
      errorMsgBgColor: RED1,
      errorMsgDarkTextColor: RED1,
      errorMsgLightTextColor: LIGHT_TEXT_COLOR,
      globalMsgBgColor: BLUE5,
      globalMsgTextColor: LIGHT_TEXT_COLOR,
      headerBgColor: BG_ACCENT,
      headerTextColor: LIGHT_TEXT_COLOR,
      lightTextColor: LIGHT_TEXT_COLOR,
      line: `solid 1px ${BG_ACCENT}`,
      linkTextColor: DARK_TEXT_COLOR,
      lotNumberBgColor: RED3,
      lotNumberTextColor: LIGHT_TEXT_COLOR,
      mobileBlockAttrsBgColor1: BACKGROUND,
      mobileBlockAttrsBgColor2: GRAY2,
      mobileBlockAttrsTextColor1: BLACK,
      mobileBlockAttrsTextColor2: BLACK,
      mobileBottomNavBgColor: BACKGROUND,
      mobileBottomNavTextColor: RED2,
      mobileCrAttrsBgColor1: BACKGROUND,
      mobileCrAttrsBgColor2: BACKGROUND,
      mobileCrAttrsTextColor1: BLACK,
      mobileCrAttrsTextColor2: BLACK,
      mobilePrevAttrsBgColor1: BACKGROUND,
      mobilePrevAttrsBgColor2: BACKGROUND,
      mobilePrevAttrsTextColor1: BLACK,
      mobilePrevAttrsTextColor2: BLACK,
      mobileRunListBgColor1: GRAY1,
      mobileRunListBgColor2: GRAY1,
      mobileRunListTextColor1: BLACK,
      mobileRunListTextColor2: BLACK,
      myProxyBgColor: YELLOW1,
      myProxyTextColor: WHITE,
      navBgColor: BACKGROUND,
      navTextColor: LIGHT_TEXT_COLOR,
      noSaleMsgBgColor: RED2,
      noSaleMsgTextColor: LIGHT_TEXT_COLOR,
      pendingMsgBgColor: YELLOW1,
      pendingMsgTextColor: WHITE,
      pinMsgBgColor: ORANGE1,
      pinMsgTextColor: LIGHT_TEXT_COLOR,
      playerMsgBgColor: ORANGE1,
      playerMsgTextColor: LIGHT_TEXT_COLOR,
      prevAttrsBgColor1: ZEBRA1,
      prevAttrsBgColor2: ZEBRA2,
      prevAttrsTextColor1: LIGHT_TEXT_COLOR,
      prevAttrsTextColor2: LIGHT_TEXT_COLOR,
      previewTitleBgColor: ZEBRA1,
      previewTitleTextColor: LIGHT_TEXT_COLOR,
      radiusBadge: `50%`,
      radiusBox: `3px`,
      radiusModal: `4px`,
      radiusNone: `0px`,
      runListBgColor1: ZEBRA5,
      runListBgColor2: ZEBRA6,
      runListHoverBgColor: BG_ACCENT,
      runListTextColor1: BLACK,
      runListTextColor2: BLACK,
      sellerItemBgColor: BROWN1,
      sellerItemTextColor: BLACK,
      sellerOkToSellBgColor: GREEN2,
      sellerOkToSellTextColor: LIGHT_TEXT_COLOR,
      sellerPassBgColor: RED2,
      sellerPassTextColor: LIGHT_TEXT_COLOR,
      sellerReserveTextColor: RED2,
      sellerTakesBgColor: BLUE4,
      sellerTakesOkBgColor: BLUE4,
      sellerTakesOkTextColor: LIGHT_TEXT_COLOR,
      sellerTakesTextColor: LIGHT_TEXT_COLOR,
      sendBtnBgColor: BLUE4,
      sendBtnTextColor: LIGHT_TEXT_COLOR,
      shadedBgColor: BACKGROUND,
      subHeaderBgColor: BG_ACCENT,
      subHeaderTextColor: LIGHT_TEXT_COLOR,
      successColor: GREEN2,
      utilityActionBgColor: BLUE4,
      utilityActionTextColor: LIGHT_TEXT_COLOR,
      utilityBtnBgColor: BLUE4,
      utilityBtnTextColor: LIGHT_TEXT_COLOR,
      watchingBgColor: BLUE2,
      watchingTextColor: LIGHT_TEXT_COLOR,
      wonMsgBgColor: GREEN2,
      wonMsgTextColor: LIGHT_TEXT_COLOR,
      watchingBgGradientColor: WATCH_GRADIENT,
    },
    overrides,
  );
};

export default abyssTheme;
